import { FC } from "react";
import tw from "twin.macro";

const baseContainerCss = tw`flex flex-col relative border border-solid border-theme bg-blossom p-4 mb-6`;
const baseFontCss = tw`text-2xs leading-3 text-theme`;
const baseCss = [baseContainerCss, baseFontCss];

interface Props {
  className?: string;
}

export const Rect: FC<Props> = ({ children, className }) => {
  return (
    <div css={baseCss} className={className}>
      {children}
    </div>
  );
};
